import c from '../util/c';

const Spacing = ({ height }: {height:`h-[${number}px]`}) => (
  <div className={c('w-full',height)} />
);

export default Spacing;
